import script from "./BaseCard.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseCard.vue?vue&type=script&setup=true&lang=js"

import "./BaseCard.vue?vue&type=style&index=0&id=08de06d6&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08de06d6"]])

export default __exports__